import confetti from "canvas-confetti";

export const fireConfetti = (opts = {}) => {
  const defaults = {
    particleCount: 90,
    spread: 70,
    startVelocity: 35,
    scalar: 0.9,
    origin: { y: 0.6 },
    colors: ["#8B5CF6", "#06B6D4", "#F59E0B", "#EC4899", "#10B981"],
  };
  confetti({ ...defaults, ...opts });
};

export const fireBigConfetti = () => {
  const end = Date.now() + 800;
  const colors = ["#8B5CF6", "#06B6D4", "#F59E0B", "#EC4899", "#10B981"];
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors });
    confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
};
